<nav>
  <div class="navbar-wrapper">
    <div class="header-logo">
      <app-nav-logo [navCollapsed]="navCollapsed" (NavCollapse)="navCollapse()" class="navbar-brand"></app-nav-logo>
    </div>
    <app-nav-content (onNavCollapsedMob)="navCollapseMob()" class="scroll-div w-100"></app-nav-content>
  </div>
  <div class="right-menu">
    <a href="javascript:" class="toggle-button" (click)="navCollapse()">
      <i-feather [name]="navCollapsed ? 'chevron-right' : 'chevron-left'"></i-feather>
    </a>
  </div>
  <button type="button" class="sidebar-close-btn" (click)="navCollapseMob()" aria-label="Close menu">
    <i-feather name="x"></i-feather>
  </button>
</nav>
